import {
  LayoutType,
  ReactIcons,
  Text,
} from "@kalyzee/escaet-ui";
import { Meeting } from "@kalyzee/kast-web-sdk/websocket";
import { PopulatedMeetingData, StudentView } from "../../../interfaces/populatedData";
import { GoTo } from "../../navigation/GoTo";
import { PageMasterMode } from "../../navigation/PageContext";
import { RemotesToExpertsContainer } from "../../player/container/RemotesToExpertsContainer";
import styles from "./PedagogyStudentContainer.module.css";

export interface GroupStudentContainerProps {
  meeting: Meeting;
  populatedMeeting: PopulatedMeetingData;
  view: StudentView;
  layout: LayoutType;
  selfVideoStream?: MediaStream;
}

export const PedagogyStudentContainer = ({ meeting, populatedMeeting, view, layout, selfVideoStream }: GroupStudentContainerProps) => {

  const renderHeader = () => {
    let notchText: string = `Groupe ${view.selfGroup?.room.name ?? ""}`;
    let NotchIcon: React.FC<React.SVGProps<SVGElement>> = ReactIcons.GroupMin;

    if (view.type === "activity_all_leaders") {
      notchText = "Tous les leaders";
      NotchIcon = ReactIcons.CrownFour;
    } else if (view.type === "activity_one_leader") {
      notchText = "Discussion avec l'expert";
      NotchIcon = ReactIcons.PedagoHeadphoneNotFilled;
    }

    if (populatedMeeting.isPedagogy) {
      notchText = "Pédagogie";
      NotchIcon = ReactIcons.PedagoHeadphoneNotFilled;
    }

    return (
      <div className={styles.groupModeHeader}>
        <NotchIcon className={styles.groupModeHeaderIcon} />
        <div className={styles.groupModeHeaderTitle}>{notchText}</div>
      </div>
    );
  };

  const renderCurrentGroup = () => {
    if (!view.selfGroup) return null;
    const studentSessions = view.students.filter(data => data.video).map(data => data.session);
    const expertSessions = view.experts.filter(data => data.video).map(data => data.session);
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {renderHeader()}
        <div
          style={{
            width: "100%",
            flex: 1,
            minHeight: 0,
            padding: 20,
          }}
        >
          <RemotesToExpertsContainer
            remoteSessions={studentSessions}
            expertSessions={expertSessions}
            self={{
              present: true,
              videoStream: selfVideoStream,
            }}
            layout={layout}
            showRemoteGroup={view.type === "activity_all_leaders"}
          />
        </div>
      </div>
    );
  };

  const renderMainMessage = (value: string, loading?: boolean) => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          fontSize: 24,
          fontWeight: 800,
          gap: 10,
        }}
      >
        <Text value={value} />
        {loading && <ReactIcons.Spinner2 style={{ width: 36, height: 36 }} />}
      </div>
    );
  };

  if (view.type !== "pedagogy_room") {
    return <GoTo page={PageMasterMode.MEETING_DASHBOARD} params={{ id: meeting.id }} />;
  } else if (view.selfGroup) {
    return renderCurrentGroup();
  } else {
    return renderMainMessage("En attente d'un agent pédagogique", true); // Should not happen
  }
};
